export default "__VITE_ASSET__CDVLtNI$__"